import { render, staticRenderFns } from "./SidebarFormConfiguration.vue?vue&type=template&id=1644fec6&scoped=true"
import script from "./SidebarFormConfiguration.vue?vue&type=script&lang=js"
export * from "./SidebarFormConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SidebarFormConfiguration.vue?vue&type=style&index=0&id=1644fec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644fec6",
  null
  
)

export default component.exports